import {
    Button,
    Box,
    FormControl,
    Grid,
    InputAdornment,
    Menu,
    MenuItem,
    Snackbar,
    TextField,
    Typography,
    makeStyles,
    Card,
    CardContent,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fab,
    Tooltip,
    CardMedia,
  } from "@material-ui/core";
  import { FaUser, FaEdit, FaTrash } from 'react-icons/fa';
  import Search from "@material-ui/icons/Search";
  import { Alert } from "@material-ui/lab";
  import * as _ from "lodash";
  import React, { useEffect, useState } from "react";
  import { connect, useSelector} from "react-redux";
  import * as miscAction from "../actions/miscAction";
  import * as modelAction from "../actions/modelAction";
  import LabelWithInput from '../components/common/controls/LabelWithInput/LabelWithInput';
  // import AddDynamicFields from "../components/common/controls/AddDynamicFields";
  import AntSwitch from "../components/common/controls/AntSwitch";
  import CustomButton from "../components/common/controls/CustomButton";
  import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
  import DMModal from "../components/common/controls/DMModal";
  import DMSelect from "../components/common/controls/DMSelect";
  import DMGrid from "../components/common/controls/Grid/DMGrid";
  import { sortMoelService } from "../services/ModelsService";
  import { uuidv4 } from "../utilities/applicationutils";
  import "./pageStyles.scss";
  import Loading from "../components/Loading/Loading";
  import { width } from "@fortawesome/free-solid-svg-icons/faSave";
  import { LineWeight } from "@material-ui/icons";
  import EditIcon from "@material-ui/icons/Edit";
  import DeleteIcon from "@material-ui/icons/Delete";
  import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
  import PersonIcon from '@material-ui/icons/Person'
  import SaveIcon from '@material-ui/icons/Save'
  import { useHistory } from 'react-router-dom';
  import Stack from '@mui/material/Stack';
  import SvgIcon from "@material-ui/core/SvgIcon";
  import { ReactComponent as CarrierOfficeIcon } from "../assets/images/carrier-office-icon.svg";
  import { ReactComponent as DevelopedEconomyIcon } from "../assets/images/developed-economy-icon.svg";
import SalesOffice from "./SalesOffice";
  var CONTROLS_DATA = require("./ControlsData.json");
  
  const Markets = ({
    modelState,
    deleteState,
    currencyState,
    createState,
    getSalesOffice,
    getMarket,
    userInfo
  }) => {
    console.log('checking market sales office',userInfo);
    const [models, setModels] = useState([]);
    //const [regionsT, setRegionsT] = useState([]);
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [showNewRegionModel, setShowNewRegionModel] = useState(false);
  
    const [showAlert, setShowAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    
    // State Management
    const [selectedMarket, setSelectedMarket] = useState(null);
    
    const onNewProjectClick = () => setShowNewRegionModel(true);
    
    const retriveSalesOfficeId = localStorage.getItem("salesOfficeValue");
    const payloadSales = { salesOfficeId : retriveSalesOfficeId}

    //My Use Effect for triple screen
    useEffect(() => { 
      console.log("Region based sales office id===>",retriveSalesOfficeId);
      const fetchMarketData = async () => {
        try {
          if(retriveSalesOfficeId){
          await getMarket(payloadSales);
        }
        }
        catch (error) {
          console.log('throws error while fetchMarketData', error);
        }
      }
      fetchMarketData();
    },[getMarket]);
  
  
    function getModalStyle() {
      const top = 50;
      const left = 50;
  
      return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
      };
    }
  
    const useStyles = makeStyles((theme) => ({
      paper: {
        position: "absolute",
        width: 400,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        maxHeight: "75%",
      },
      formControl: {
        margin: theme.spacing(1),
        minWidth: 222,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      gridHeaderColumns: {
        display: "grid",
        width: "100%",
        gridTemplateColumns: "45% 30% 15% 10%",
        color: "#617080",
        fontSize: "14px",
        fontFamily: "Arial",
        fontWeight: "500",
      },
    }));
  
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
  
    const [anchorEl, setAnchorEl] = React.useState(null);
    
    const marketOfficeData = useSelector((state) => state.model.tripleScreen.market ? state.model.tripleScreen.market : []);

    console.log("Markets data===>",marketOfficeData);
    
    return (
      <div container className="page-container content-center">
        <Loading open={loading} />
        <Grid container xs={4} md={9} className="page-content card-cotent-market">
          {/* Market Card */}
          {/* {selectedOffice && ( */}
            <div className="card-header-info">
                <Typography variant="h6" className="card-header-typograpy">Markets</Typography>
            </div>
            <Card style={{ minWidth: 275,width:'100%',backgroundColor:'#E5E7ED' }}>
              <CardContent>
                {/* <Typography variant="h6">Markets</Typography> */}
                {marketOfficeData && marketOfficeData.map((market) => (
                  <div
                    key={market?.marketId}
                    className="btn-cluster-grp"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '8px',
                      cursor: 'pointer',
                      gap: '8px',
                      borderRadius:'4px',
                      alignItems:"center",
                      marginBottom:"8px",
                      backgroundColor: selectedMarket?.marketId === market?.marketId ? '#1891F6' : '#FFFFFF',
                    }}
                    onClick={() => setSelectedMarket(market)}
                  >
                    <Typography>{market?.marketName}</Typography>
                    <div className="grid-icon">
                    </div>
                  </div>
                ))}
              </CardContent>
            </Card>
          {/* )} */}
        </Grid>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={() => setShowAlert(false)}
        >
          <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Snackbar>
      </div>
    );
  };
  
  const mapStateToProps = (state) => ({
    modelState: state.model,
    salesOfficeData : state.model.tripleScreen.sales || [],
    deleteState: state.model.deleteModel,
    currencyState: state.model.currency,
    createState: state.model.createNewModel
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
      onModelSelected: async(modelType) => dispatch(miscAction.onModelSelected(modelType)),
      setSnackBar: (show, severity, message) =>
        dispatch(miscAction.setSnackBar(show, severity, message)),
      onPageSelected: (selectedPage) =>
        dispatch(modelAction.setModelSelectedPage(selectedPage)),
      onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
    //   getRegionsT: async() => dispatch(modelAction.getRegionsT()),
    //   getSalesOffice: async(region) => dispatch(modelAction.getSalesOffice(region)),
      getMarket: async(sales) => dispatch(modelAction.getMarket(sales)),
      getCurrency: async() => dispatch(modelAction.getCurrency())
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Markets);
  